import { type CservOnlineTools } from '../dtos';

const tools = {
  ms_teams: 'MS Teams',
  LUX: 'LUX',
  techcast: 'Techcast',
  tricat: 'TriCAT',
  zoom: 'Zoom',
} as const satisfies Record<CservOnlineTools, string>;

export const content = {
  loadingMessage: 'Lädt ...',
  noInfoAvailable: '-',
  units: {
    tage: 'Tag(e)',
    stunden: 'Stunde(n)',
    tag: 'Tag',
    qm: 'm²',
    percent: '%',
  },
  /**
   * Variant of "units" that provide a preceding whitespace.
   *
   * NOTE:
   * Some units are separated from their corresponding number by a "Narrow Non-Breaking Space" (NNBSP)
   * (see https://en.wikipedia.org/wiki/Non-breaking_space#Narrow_non-breaking_space)
   * Be careful when editing such whitespaces since depending on the editor you are using you might
   * not see any difference in the code.
   */
  unitsWs: {
    tage: ' Tag(e)',
    stunden: ' Stunde(n)',
    tag: ' Tag',
    qm: ' m²', // NNBSP - see comment above
    percent: ' %', // NNBSP - see comment above
  },
  ja: 'ja',
  nein: 'nein',
  missingThemaLink: 'Link konnte nicht geladen werden, weil verknüpftes Produkt nicht in Viva gefunden werden konnte.',
  vivaStatus: {
    inPlanung: 'In Planung',
    abgeschlossen: 'Planung abgeschlossen',
    freigegeben: 'Planung freigegeben',
    imAusschreibungsportal: 'Im Ausschreibungsportal',
  },
  columnLabels: {
    shortIndex: '#',
    akaDurchgangId: 'AKA-Durchgang-ID',
    leistungId: 'Leistungs-ID',
    leistungIndex: 'Leistungs-Index',
    statusAP: 'AP-Status',
    antwortAP: 'Rückmeldung',
    akaVeranstaltungId: 'AKA-Veranstaltung-ID',
    durchgangSapId: 'SAP-ID',
    veranstaltungSapId: 'SAP-ID',
    titel: 'Titel',
    start: 'Beginn',
    end: 'Ende',
    status: 'VIVA-Status',
    kuerzel: 'Kürzel',
    regionName: 'Region',
    meetingTool: 'Meeting-Tool',
    experten: 'Trainer:in',
    buchungsnummer: 'Buchungsnummer',
    fehler: 'Fehler-Level',
    wo: 'Wo?',
    terminart: 'Terminart',
    durchgangsart: 'Durchgangsart',
    vNummer: 'V-Nummer',
    modulnummer: '#',
  },
  tooltips: {
    zumDurchgangWechseln: 'Zum Durchgang wechseln',
    zurVeranstaltungWechseln: 'Zur Veranstaltung wechseln',
    zumModulterminWechseln: 'Zur Modultermin wechseln',
    zumThemaWechseln: 'Zum Thema wechseln',
    processing: 'Daten werden verarbeitet...',
    statusAP: 'Status Ausschreibungsportal',
    antwortAP: 'Antworten aus dem Ausschreibungsportal',
  },
  tools,
} as const;

export const printWithNoInfo = (input: string | undefined | null | number): string => {
  if (typeof input === 'number') {
    return input.toString();
  }

  if (typeof input === 'string' && input.length > 0) {
    return input;
  }

  return content.noInfoAvailable;
};
